export default {
	'system.role.title': '角色信息',
	'system.role.role_id': '角色编号',
	'system.role.role_name': '角色名称',
	'system.role.role_key': '权限字符',
	'system.role.role_sort': '显示顺序',
	'system.role.data_scope': '数据范围',
	'system.role.menu_check_strictly': '菜单树选择项是否关联显示',
	'system.role.dept_check_strictly': '部门树选择项是否关联显示',
	'system.role.status': '角色状态',
	'system.role.del_flag': '删除标志',
	'system.role.create_by': '创建者',
	'system.role.create_time': '创建时间',
	'system.role.update_by': '更新者',
	'system.role.update_time': '更新时间',
	'system.role.remark': '备注',
	'system.role.auth': '菜单权限',
	'system.role.auth.user': '选择用户',
	'system.role.auth.addUser': '添加用户',
	'system.role.auth.cancelAll': '批量取消授权',
};
